import React, { useEffect } from 'react';
// REDUX
import { useSelector } from 'react-redux';
// ACTION
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';

import { history } from 'app/store';

import checkPrevLink from '../../Utility/checkPrevUrlLink';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import withMobileDetecting from 'app/components/HOGs/detectMobileDesign';
import withTranslations from 'app/components/HOGs/withTranslations';
import { getQueryStringParams } from '../../Utility/utility';
// API
import { placeAPI } from '../../../API/place.service.api';
// COMPONENTS
import PlacesView from './placesView';
import PlaceFullMobile from '../../Mobile/Place/place.mobile';
// CSS
import './places.css';
// DATA EMPTY
import { PlaceEmpty } from './emptyDataPlace';
// INTL
// CONST
const getPlaceId = ({ location = {} }) =>
  location.pathname
    ? parseInt(
        location.pathname
          .replace(/[^\w\s]/gi, '')
          .replace(' ', '_')
          .split('_')
          .splice(-1)
          .pop()
      )
    : 0;

const isCreatePlace = ({ location = {} }) =>
  location.pathname
    ? location.pathname.split('/')[location.pathname.split('/').length - 1] ===
      'create'
    : false;

let currentPlaceId = 0;
let isCreate = false;

const PlacesContainer = (props) => {
  const { isMobileDesign } = props;

  const {
    PlaceSetInitialState,
    PlaceSetEditMode,
    PlacesSetEmptyData,
    PlaceUserAmount,
    PlacesSetError,
    PlaceDataAddOwner,
    PlacePointGet,
    PlaceSetBookmark,
    PlaceSetAccessibilityType,
    PlaceSetCategory,
    PlaceSetIconType,
    PlaceSetIconColor,
    PlaceUpdateImage,
    PlaceSetTitle,
    openModalTourDownload,
    TourDownloadBasketData,
    TourDownloadCoord,
    scope,
    mainMenuCollapse,
  } = useActions();

  const isEditMode = useSelector((store) => store.placesData.isEditMode);
  const owner = useSelector((store) => store.placesData.data.user);

  const placesData = useSelector((store) => store.placesData);

  const error = useSelector((store) => store.placesData.error);

  const downloadTourGps = useSelector((store) => store.tourDownload);

  const router = useSelector((store) => store.router);
  const { previousLocation, currentLocation } = useSelector(
    (store) => store.locationUrl
  );
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const user = useSelector((store) => store.authentication.user);

  const { share_key: shareKey } = getQueryStringParams(router.location.search);

  const getFullPlaceData = () => {
    placeAPI
      .getPlaceFullDataById(getPlaceId(router), shareKey)
      .then((res) => {
        const { code, response, message } = res;
        if (code === 200) {
          PlaceSetCategory(response.options.category);
          PlaceSetIconType(response.options.type);
          PlaceSetIconColor(response.options.color);
          PlacesSetEmptyData(response);
        } else {
          PlacesSetError(message);
        }
      })
      .catch((err) => PlacesSetError(err));
  };

  useEffect(() => {
    currentPlaceId = getPlaceId(router);
    isCreate = isCreatePlace(router);
    scope('place');
    if (isCreate === true) {
      PlaceSetEditMode(true);
      PlacesSetEmptyData(PlaceEmpty(user));
      PlaceUserAmount();
    }
    if (currentPlaceId !== 0 && !isCreate) {
      getFullPlaceData();
    }
    mainMenuCollapse(true);
    return () => {
      mainMenuCollapse(false);
      PlaceSetInitialState();
      publish(way.PLACE_MAP_CLEAN);
    };
  }, []);

  useEffect(() => {
    if (error) {
      history.push('/place');
    }
  }, [error]);

  useEffect(() => {
    const newId = getPlaceId(router);
    const isCreate = isCreatePlace(router);
    if (newId && newId !== currentPlaceId) {
      currentPlaceId = newId;
      getFullPlaceData();
    }
    if (isCreate) {
      PlaceSetInitialState();
      PlaceSetEditMode(isCreatePlace(router));
      PlacesSetEmptyData(PlaceEmpty(user));
      PlaceUserAmount();
    }
  }, [router.location.pathname]);

  useEffect(() => {
    if (isLoggedIn && isEditMode && !owner?.id) {
      const { id = '', name = '', sex = '', avatar = '' } = user;
      const owner = {
        id: id.toString(),
        name,
        sex,
        avatar,
      };
      PlaceDataAddOwner(owner);
    }
  }, [isLoggedIn]);

  const handleClose = () => {
    publish(way.DRIVE_CHANGE_CURSOR_ICON, {});
    checkPrevLink(previousLocation, currentLocation);
  };

  const useAdaptive = (AdaptProps) =>
    isMobileDesign ? (
      <PlaceFullMobile {...AdaptProps} />
    ) : (
      <PlacesView {...AdaptProps} />
    );

  return useAdaptive({
    edit: isEditMode,
    PlaceSetEditMode,
    isCreatePlace,
    placesData,
    authUserData: user,
    PlaceSetBookmark,
    PlaceSetAccessibilityType,
    PlacePointGet,
    PlaceSetCategory,
    PlaceSetIconType,
    PlaceSetIconColor,
    PlaceUpdateImage,
    PlaceSetTitle,
    router,
    downloadTourGps,
    openModalTourDownload,
    TourDownloadBasketData,
    TourDownloadCoord,
    currentPlaceId,
    handleClose,
  });
};

export default withMobileDetecting(withTranslations(PlacesContainer));
